<template>
<router-view/>
</template>

<script>
export default {
  name: "AnonymousView"
}
</script>

<style scoped>

</style>